import { COUNTRIES } from '@config/constants'

export const HIDE_DISCOUNT_LABEL = {
  [COUNTRIES.FR]: true,
}
